import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { ERROR_LOG_ENABLED, logErrorDetail } from './error-log';

/**
 * Records every failed call — method, URL, status and the whole body, stack included — on the
 * developer console in development builds, and rethrows it untouched so the services' own
 * `withApiError()` still reads the body. Registered first, so it sees what the inner interceptors
 * (mocks, token refresh) finally let through.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const logEnabled = inject(ERROR_LOG_ENABLED);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        logErrorDetail(logEnabled, `http ${req.method} ${error.url ?? req.urlWithParams}`, error);
      }
      return throwError(() => error);
    })
  );
};
